<template>
    <div
        class="flex flex-column gap-3"
        ref="container"
    >
        <div class="flex w-full">
            <div class="field relative w-full">
                <div class="">
                    <AdaptersDropdown
                        v-model="model"
                        :options="searchSettings"
                        class=" w-full"
                        :hoverUsage="true"
                    >
                        <template #value="{value}">
                            <div class="flex align-items-center justify-content-between">
                                <div class="flex align-items-center gap-3">
                                    <div class="flex align-items-center">
                                        <img class="max-h-1rem border-circle mr-2" :title="value.engine.caption" :src="value.engine.icon" />
                                        <div v-if="isMobileStyles">&nbsp;</div>
                                        <div v-else class="text-color-secondary">
                                            {{ value.engine.caption }}
                                        </div>
                                    </div>
                                    <span>{{ value.region.short_title }}</span>
                                </div>
                                <i
                                    class="pi"
                                    :class="'pi-' + value.device"
                                    style="padding: 8px;"
                                ></i>
                            </div>
                        </template>
                        <template #option="{option}">
                            <div class="flex align-items-center justify-content-between w-full">
                                <div class="flex align-items-center gap-3">
                                    <div class="flex align-items-center">
                                        <img class="max-h-1rem border-circle mr-2" :title="option.engine.caption" :src="option.engine.icon" />
                                        <div v-if="isMobileStyles">&nbsp;</div>
                                        <div v-else class="clustering_select_region__engine text-color-secondary">
                                            {{ option.engine.caption }}
                                        </div>
                                    </div>
                                    <span>{{ option.region.short_title }}</span>
                                </div>
                                <i
                                    class="pi"
                                    :class="'pi-' + option.device"
                                    style="padding: 8px;"
                                ></i>
                            </div>
                        </template>
                    </AdaptersDropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdaptersAutoComplete from "../../../component/adapters/AutoComplete.vue";
import AdaptersDropdown from "../../../component/adapters/Dropdown.vue";
import Button from "primevue/button";

export default {
    name: 'ClusteringSelectRegions',
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        searchSettings: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            model: {},
            isMobile: false,
        };
    },
    created() {
        this.model = this.modelValue;
    },
    mounted() {
        this.checkMobileStyles();
        window.addEventListener('resize', this.checkMobileStyles);
    },
    computed: {
        isMobileStyles() {
            return this.isMobile;
        },
    },
    methods: {
        checkMobileStyles() {
            this.isMobile = this.$refs.container.offsetWidth < 400;
        },
    },
    watch: {
        model: {
            handler(newModelValue) {
                this.$emit('update:modelValue', newModelValue);
            },
            deep: true,
        }
    },
    components: {
        AdaptersDropdown,
        AdaptersAutoComplete,
        Button,
    },
}
</script>

<style scoped>
.clustering_select_region__engine {
    min-width: 50px;
}
</style>
